import React from 'react';

import AudioInputList from './AudioInputList/AudioInputList';
import AudioOutputList from './AudioOutputList/AudioOutputList';
import { DialogContent } from '@mui/material';
import { makeStyles } from '@mui/styles';
import VideoInputList from './VideoInputList/VideoInputList';

const useStyles = makeStyles({
  listSection: {
    margin: '2em 0',
    '&:first-child': {
      margin: '1em 0 2em 0',
    },
  },
});

export function DeviceSelector({ className, hidden }: { className?: string; hidden?: boolean }) {
  const classes = useStyles();

  return (
    <DialogContent className={className} hidden={hidden}>
      <div className={classes.listSection}>
        <AudioInputList />
      </div>
      <div className={classes.listSection}>
        <AudioOutputList />
      </div>
      <div className={classes.listSection}>
        <VideoInputList />
      </div>
    </DialogContent>
  );
}

export function AudioDeviceSelector({ className, hidden }: { className?: string; hidden?: boolean }) {
  const classes = useStyles();

  return (
    <DialogContent className={className} hidden={hidden}>
      <div className={classes.listSection}>
        <AudioInputList />
      </div>
      <div className={classes.listSection}>
        <AudioOutputList />
      </div>
    </DialogContent>
  );
}

export function VideoDeviceSelector({ className, hidden }: { className?: string; hidden?: boolean }) {
  const classes = useStyles();

  return (
    <DialogContent className={className} hidden={hidden}>
      <div className={classes.listSection}>
        <VideoInputList />
      </div>
    </DialogContent>
  );
}
